import { brightenHex } from '../utils.js';

AFRAME.registerComponent('letter-hover', {
  init: function () {
    this._onEnter = this._onEnter.bind(this);
    this._onLeave = this._onLeave.bind(this);
    this.el.addEventListener('mouseenter', this._onEnter);
    this.el.addEventListener('mouseleave', this._onLeave);
  },
  _onEnter: function () {
    // Guard: do not apply hover effect during entrance animation.
    // letter-hover is attached at spawn time (before animation), but letter-click
    // is only added after animationcomplete__scale. Using the same gate here
    // prevents setAttribute('scale') from fighting the running animation__scale.
    if (!this.el.classList.contains('clickable-letter')) { return; }
    this.el.setAttribute('scale', '1.3 1.3 1.3');
    const originalColor = this.el.dataset.color || '#ffffff';
    if (originalColor) {
      this.el.setAttribute('text', 'color', brightenHex(originalColor));
    }
  },
  _onLeave: function () {
    if (!this.el.classList.contains('clickable-letter')) { return; }
    this.el.setAttribute('scale', '1 1 1');
    const originalColor = this.el.dataset.color || '#ffffff';
    if (originalColor) {
      this.el.setAttribute('text', 'color', originalColor);
    }
  },
  remove: function () {
    this.el.removeEventListener('mouseenter', this._onEnter);
    this.el.removeEventListener('mouseleave', this._onLeave);
  },
});

if (import.meta.hot) { import.meta.hot.decline(); }
